/* tslint:disable */
/* eslint-disable */
export enum ActiveReportEnum {
  Reach = 0,
  Exposures = 1,
  PeopleCounter = 2,
  POI = 3
}
